import type { Ref } from '@vue/composition-api';
import { ref } from '@vue/composition-api';

export function useTimer() {
  let timer: ReturnType<typeof setInterval> = null;
  const elapsedTime: Ref<number> = ref(0);

  const stopTimer = () => {
    if (!timer) {
      return;
    }
    clearInterval(timer);
    timer = null;
  };

  const elapseTime = () => elapsedTime.value++;

  const startTimer = () => {
    if (timer) {
      return;
    }
    timer = setInterval(elapseTime, 1000);
  };

  return {
    stopTimer,
    startTimer,
    elapsedTime,
  };
}
